/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 轮询时间（秒）
 */
export const DEVICE_MODE_POLLING_TIME = 15;

/**
 * 开局状态
 */
export enum DeploymentStatusE {
    /** 未开局 */
    UNDEPLOYED = 0,
    /** 开局中 */
    IN_DEPLOYMENT = 1,
    /** 已开局 */
    DEPLOYED = 2,
}
